import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { refreshToken } from '../redux/actions/authentication/refreshTokenActions';

import useInterval from './useInterval';

export default function useRefreshToken() {
  const dispatch = useDispatch();
  const location = useLocation();

  const laps = 30 * 60 * 1000;

  useInterval(() => {
    dispatch(refreshToken(location.pathname, location.search));
  }, laps);
}
